class MFRProductTopAddons {
  constructor( i, e, options ) {
    this.$index = i

    this.$element = $( e )

    this.selectors = {
      addOnForm: ".product-top__addon-form",
      addOnFormVariantRadio: "input[name='product-addons-variant']",
      addOnFormButton: ".addon-form-button",
      addOnFormQtyInput: ".addons-quantity-selector__input",
      addOnFormPriceInput: ".addons-price-selector__input",
      addOnFormPriceInputTotal: ".addons-price-selector__input-total",
      addOnParent: ".product-top__addon--product",
      addOnVariantButton: ".addon-form-variants"
    }

    this.options = options
    this.addOnComponent = $(this.options.addOnComponent)

    this.states = {
      addOnsArray: [],
      addOnsTotalPrice: 0
    }

    this.init()
  }

  init() {
    this.$addOnFormButton = this.addOnComponent.find(this.selectors.addOnFormButton)
    this.$addOnFormVariantRadio = this.addOnComponent.find(this.selectors.addOnFormVariantRadio)
    this.$addOnFormQtyInput = this.addOnComponent.find(this.selectors.addOnFormQtyInput)
    this.$addOnFormPriceInput = this.addOnComponent.find(this.selectors.addOnFormPriceInput)
    this.$addOnFormPriceInputTotal = this.addOnComponent.find(this.selectors.addOnFormPriceInputTotal)
    this.$addOnVariantButton = this.addOnComponent.find(this.selectors.addOnVariantButton)

    $(document).on("mfr:add-to-cart", this.__handleAddToCart.bind(this))
    this.$addOnFormButton.on("click", this.addProductsAddOnsArray.bind(this))
    this.$addOnFormVariantRadio.on("change", this.changeProductsAddOnsVariant.bind(this))
    this.$addOnVariantButton.on("click", this.__showVariantsOptions.bind(this))
  }

  __handleAddToCart(e) {
    const addOnsARR = this.states.addOnsArray

    CartJS.addItems([
      ...addOnsARR
    ])
  }

  __handleAddOnsProductPrices() {
    let addOnsARR = this.states.addOnsArray
    let productsARR = [this.formToObject($(`${this.options.mainForm}`)), ...addOnsARR]
    let productARRPricesTotal = 0
    let addonsPricesTotal = 0

    for ( let product of productsARR ) {
      productARRPricesTotal += (parseInt(product.properties._current_price) * parseInt(product.quantity))
    }

    for ( let product of addOnsARR ) {
      addonsPricesTotal += (parseInt(product.properties._current_price) * parseInt(product.quantity))
    }

    this.$addOnFormPriceInputTotal.val(addonsPricesTotal);
    return productARRPricesTotal
  }

  __showVariantsOptions(e) {
    const $variantsOptions = $(e.currentTarget).parents('.product-top__addon--product-inner').siblings('.product-top__addon--product-variants--inner')

    this.removeProductsAddOnsVariant($variantsOptions)
    $(e.currentTarget).toggleClass('is-added')
    $variantsOptions.slideToggle()
  }

  addProductsAddOnsArray(formButton) {
    if ( $(formButton.currentTarget).get(0).type === 'button' ) {
      let product_id = this.formToObject($(formButton.currentTarget).parents(this.selectors.addOnParent).find('form')).id

      if ( this.states.addOnsArray.some(item => parseInt(item.id) === parseInt(product_id)) ) {
        let product_to_remove = this.states.addOnsArray.findIndex(item => parseInt(item.id) === parseInt(product_id))

        if ( product_to_remove !== -1 ) {
          this.states.addOnsArray.splice(product_to_remove, 1)
        }

        $(formButton.currentTarget).removeClass('is-added')
      } else {
        this.states.addOnsArray.push(this.formToObject($(formButton.currentTarget).parents(this.selectors.addOnParent).find('form')))
        $(formButton.currentTarget).addClass('is-added')
      }
    } else {
      this.states.addOnsArray.push(this.formToObject($(formButton.currentTarget).parents('form')))
      $(formButton.currentTarget).addClass('is-added')
    }

    this.states.addOnsTotalPrice = this.__handleAddOnsProductPrices()
    this.$addOnFormQtyInput.val(parseInt( this.states.addOnsArray.length ))
    this.$addOnFormPriceInput.val(parseInt( this.states.addOnsTotalPrice ))
    this.addOnComponent.trigger( "mfr:addons-quantity-changed", [ parseInt( this.states.addOnsArray.length ) ] )

    return this.states.addOnsArray
  }

  removeProductsAddOnsVariant(variants) {
    let thisAddOnsArray = this.states.addOnsArray

    variants.each(function() {
      let $checkedOptions = $(this).find('form').find('input[type="radio"]:checked')
      let product_id = $(this).find('form').find('input[type="radio"]:checked').val()
      let product_to_remove = thisAddOnsArray.findIndex(item => parseInt(item.id) === parseInt(product_id))

      if ( $checkedOptions.length > 0 ) {
        $checkedOptions.prop("checked", false)

        if ( product_to_remove !== -1 ) {
          thisAddOnsArray.splice(product_to_remove, 1)
        }
      }
    })

    this.states.addOnsTotalPrice = this.__handleAddOnsProductPrices()
    this.$addOnFormQtyInput.val(parseInt( this.states.addOnsArray.length ))
    this.$addOnFormPriceInput.val(parseInt( this.states.addOnsTotalPrice ))
    this.addOnComponent.trigger( "mfr:addons-quantity-changed", [ parseInt( this.states.addOnsArray.length ) ] )
  }

  changeProductsAddOnsVariant(variant) {
    let $variant_form = $(variant.currentTarget).parents('.product-top__addon--product-variants').find('form')
    let variant_form_parent_product_id = $variant_form.find('input[name="properties[_addon_parent_product]"]').val()
    let variant_id = $(variant.currentTarget).val()

    $variant_form.find('input[name="id"]').val(variant_id)

    if ( this.states.addOnsArray.some(item => item.properties._addon_parent_product == variant_form_parent_product_id) ) {
      let product_to_remove = this.states.addOnsArray.findIndex(item => item.properties._addon_parent_product == variant_form_parent_product_id)

      if ( product_to_remove !== -1 ) {
        this.states.addOnsArray.splice(product_to_remove, 1)
      }
    }

    this.addProductsAddOnsArray(variant)
  }

  formToObject(form) {
    if( !form.length ) return
    form = form.get(0)
    const myFormData = new FormData(form)
    const formData = Object.fromEntries(myFormData.entries())
    const convertedFormData = {}

    for (const key in formData) {
      if (formData.hasOwnProperty(key)) {
        const keys = key.split(/[\[\]]+/).filter(Boolean) // Split key by square brackets
        let currentObj = convertedFormData

        for (let i = 0; i < keys.length; i++) {
          const isLastKey = i === keys.length - 1
          const nestedKey = keys[i]

          if (isLastKey) {
            if ( keys[i] === 'quantity' || keys[i] === 'id' || keys[i] === 'product-id') {
              currentObj[nestedKey] = parseInt(formData[key])
            } else {
              currentObj[nestedKey] = formData[key]
            }
          } else {
            currentObj[nestedKey] = currentObj[nestedKey] || {} // Create nested object if it doesn't exist
            currentObj = currentObj[nestedKey]
          }
        }
      }
    }
    return convertedFormData
  }
}